const Index = ({ label }: { label: string }) => (
  <h5 style={{ marginBottom: 3, marginTop: 3 }}>{label}</h5>
);

export default Index;
